import { get } from "lodash";
import moment from "moment";
import { useEffect } from "react";
import { DetailAttendantType } from "routes/group/types";
import { useGetDetailAttendant } from "routes/group/hooks/useGetDetailAttendant";
import Button from "components/button";
import { Modal } from "components/modal";
import { FullScreenLoading } from "components/fullScreenLoading";
import { Label } from "components/label";
import Input from "components/input";

interface PropType {
  id: string; // attendant_id
  open: boolean;
  handleClose: () => void;
}

const AttendantDetailForm = (props: PropType) => {
  const { id, open, handleClose } = props;

  const { data, loading, fetchData } = useGetDetailAttendant();

  const handleCloseModal = () => {
    handleClose();
  };

  const keyToLabel = (key: string): string => {
    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  const handleformatDob = (value: string) => {
    const m = moment(value, "YYYY-MM-DD", true); // strict
    return m.isValid() ? m.format("DD-MM-YYYY") : "";
  };

  useEffect(() => {
    if (id) fetchData(id);
  }, [id]);

  return (
    <>
      {loading && <FullScreenLoading />}

      <Modal
        open={open}
        onClose={handleCloseModal}
        title={`Attendant Information`}
        closeOnClickBackdrop={false}
      >
        <form className="p-5 flex flex-col gap-5">
          <h3 className="font-semibold">
            {get(data, "ticket_name.name_vi", "")} /{" "}
            {get(data, "ticket_name.name_en", "")}
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-8">
            {Object.entries(get(data, "template_data", {}))?.map(
              ([key, value]) => {
                if (key === "is_agree_to_refund_policy") {
                  return (
                    <div key={key} className="flex flex-col gap-1">
                      <Label required={false} id={key} name={keyToLabel(key)} />

                      <Input type="checkbox" id={key} checked={value} />
                    </div>
                  );
                }

                return (
                  <div key={key} className="flex flex-col gap-1">
                    <Label required={false} id={key} name={keyToLabel(key)} />

                    <span className="text-[14px]">{value}</span>
                  </div>
                );
              }
            )}
          </div>

          <div className="flex items-center justify-end gap-x-3">
            <Button
              className="w-20 bg-white text-brand-500 border border-solid border-brand-500 hover:bg-gray-50 active:bg-gray-100"
              onClick={handleCloseModal}
            >
              Cancel
            </Button>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default AttendantDetailForm;
